// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: set or clear ("") a bookmark's note (favorites-bookmarks-plan.md sections 2.1 and 4). True when the
// server took it; otherwise a toast, and the caller keeps the text. Exclude from upstream sync.

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {FavoritesBookmarksStrings} from '@app/features/messaging/FavoritesBookmarksStrings';
import BookmarkNotes from '@app/features/messaging/state/BookmarkNotes';
import {http} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';

const logger = new Logger('BookmarkNotes');

interface SavedMessageNoteResponse {
	message_id: string;
	note: string;
}

export function savedMessageNotePath(messageId: string): string {
	return `${Endpoints.USER_SAVED_MESSAGE(messageId)}/note`;
}

export async function setNote(messageId: string, note: string): Promise<boolean> {
	try {
		const response = await http.put<SavedMessageNoteResponse>(savedMessageNotePath(messageId), {body: {note}});
		BookmarkNotes.set(messageId, response.body?.note ?? note);
		return true;
	} catch (error) {
		logger.error('Saving a bookmark note failed:', error);
		ToastCommands.createToast({type: 'error', children: FavoritesBookmarksStrings.noteNotSaved});
		return false;
	}
}
